/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-12 17:03:33
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-12-25 19:41:01
 */
const title = '广水市农业供应链数字平台大数据中心'
const getTitle = function(til) {
  console.log(til)
  // let allTitle = til + ' - ' + title
  let allTitle = title
  return allTitle
}
export default getTitle
